import { HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { AuthService } from './auth.service';
// export const headerInterceptor: HttpInterceptorFn = (req:HttpRequest<any>, next:HttpHandlerFn):Observable<HttpEvent<any>> => {
//   const cksrv = inject(CookiesService)

//   const newReq = req.clone({
//     setHeaders:{
//       Authorization: `bearer ${cksrv.cookieGet("UID")}`
//     }
//   }) 
//   return next(newReq);
// };


// import { AuthService } from './auth.service';

export const headerInterceptor: HttpInterceptorFn = (req: HttpRequest<any>, next: HttpHandlerFn): Observable<HttpEvent<any>> => {
  const auth = inject(AuthService);
  const token = auth.getAccessToken();
  const authReq = token ? req.clone({
    setHeaders: { Authorization: `bearer ${token}` }
  }) : req;

  return next(authReq).pipe(
    catchError(err => {
      if (err.status === 401) {
        return auth.refreshToken().pipe(
          switchMap(res => {
            auth.setAccessToken(res.accessToken);
            const retryReq = req.clone({
              setHeaders: { Authorization: `bearer ${res.accessToken}` }
            });
            return next(retryReq);
          }),
          catchError((refreshErr) => {
             auth.logout(refreshErr);
            return throwError(() => err);
          })
        );
      }
      return throwError(() => auth.logout(err));
    })
  );
};
